export default [
  {
    path: '/bars/about',
    name: 'bars-about',
    component:() => import('@/views/bars/about/AboutEdit.vue'),
  },
    {
      path: '/bars/menu',
      name: 'bars-menu',
      component: () => import('@/views/bars/menu/menus-list/MenusList.vue'),
    },
    {
      path: '/bars/gallery',
      name: 'bars-gallery',
      component:() => import('@/views/bars/store_gallery/StoreGalleryEdit.vue'),
      // component:() => import('@/views/bars/gallery/galleries-list/GalleriesList.vue'),
    },
    {
      path: '/bars/event',
      name: 'bars-event',
      component:() => import('@/views/bars/event/events-list/EventsList.vue'),
    },
    {
      path: '/bars/contact',
      name: 'bars-contact',
      component:() => import('@/views/bars/contact/ContactEdit.vue'),
    },
    {
      path: '/bars/service',
      name: 'bars-service',
      component:() => import('@/views/bars/service/services-list/ServicesList.vue'),
    },
    {
      path: '/bars/banner',
      name: 'bars-banner',
      component:() => import('@/views/bars/banner/BannerEdit.vue')
    },
    {
      path: '/bars/setting',
      name: 'bars-setting',
      component:() => import('@/views/bars/setting/SettingEdit.vue')
    },
    {
      path: '/bars/message',
      name: 'bars-message',
      component:() => import('@/views/bars/message/messages-list/MessagesList.vue')
    },
    { 
      path: '/bars/list',
      name: 'bars-list',
      component: () => import('@/views/bars/banner/banners-list/BannersList.vue')
    }
  ]
  